/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeDataCategory } from './EmployeeDataCategory';
import {
    EmployeeDataCategoryFromJSON,
    EmployeeDataCategoryFromJSONTyped,
    EmployeeDataCategoryToJSON,
    EmployeeDataCategoryToJSONTyped,
} from './EmployeeDataCategory';
import type { VisibilityConditionGroup } from './VisibilityConditionGroup';
import {
    VisibilityConditionGroupFromJSON,
    VisibilityConditionGroupFromJSONTyped,
    VisibilityConditionGroupToJSON,
    VisibilityConditionGroupToJSONTyped,
} from './VisibilityConditionGroup';
import type { ProcessingPurpose } from './ProcessingPurpose';
import {
    ProcessingPurposeFromJSON,
    ProcessingPurposeFromJSONTyped,
    ProcessingPurposeToJSON,
    ProcessingPurposeToJSONTyped,
} from './ProcessingPurpose';
import type { TableColumnConfigDto } from './TableColumnConfigDto';
import {
    TableColumnConfigDtoFromJSON,
    TableColumnConfigDtoFromJSONTyped,
    TableColumnConfigDtoToJSON,
    TableColumnConfigDtoToJSONTyped,
} from './TableColumnConfigDto';

/**
 * 
 * @export
 * @interface FormOptionDto
 */
export interface FormOptionDto {
    /**
     * 
     * @type {string}
     * @memberof FormOptionDto
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof FormOptionDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FormOptionDto
     */
    description?: string;
    /**
     * Legal statement for this option.
     * @type {string}
     * @memberof FormOptionDto
     */
    statement?: string;
    /**
     * 
     * @type {ProcessingPurpose}
     * @memberof FormOptionDto
     */
    processingPurpose: ProcessingPurpose;
    /**
     * 
     * @type {EmployeeDataCategory}
     * @memberof FormOptionDto
     */
    employeeDataCategory: EmployeeDataCategory;
    /**
     * 
     * @type {TableColumnConfigDto}
     * @memberof FormOptionDto
     */
    columnConfig?: TableColumnConfigDto;
    /**
     * If false, this column (header and cells) is excluded from the PDF/document export, independent of optionVisibilityConditions.
     * @type {boolean}
     * @memberof FormOptionDto
     */
    isVisibleInDocumentExport?: boolean;
    /**
     * 
     * @type {VisibilityConditionGroup}
     * @memberof FormOptionDto
     */
    optionVisibilityConditions?: VisibilityConditionGroup;
    /**
     * CHECKBOX option only. If true, selecting this option clears and locks every other option of the element; selecting any other option clears this one.
     * @type {boolean}
     * @memberof FormOptionDto
     */
    isExclusive?: boolean;
}



/**
 * Check if a given object implements the FormOptionDto interface.
 */
export function instanceOfFormOptionDto(value: object): value is FormOptionDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('processingPurpose' in value) || value['processingPurpose'] === undefined) return false;
    if (!('employeeDataCategory' in value) || value['employeeDataCategory'] === undefined) return false;
    return true;
}

export function FormOptionDtoFromJSON(json: any): FormOptionDto {
    return FormOptionDtoFromJSONTyped(json, false);
}

export function FormOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'statement': json['statement'] == null ? undefined : json['statement'],
        'processingPurpose': ProcessingPurposeFromJSON(json['processingPurpose']),
        'employeeDataCategory': EmployeeDataCategoryFromJSON(json['employeeDataCategory']),
        'columnConfig': json['columnConfig'] == null ? undefined : TableColumnConfigDtoFromJSON(json['columnConfig']),
        'isVisibleInDocumentExport': json['isVisibleInDocumentExport'] == null ? undefined : json['isVisibleInDocumentExport'],
        'optionVisibilityConditions': json['optionVisibilityConditions'] == null ? undefined : VisibilityConditionGroupFromJSON(json['optionVisibilityConditions']),
        'isExclusive': json['isExclusive'] == null ? undefined : json['isExclusive'],
    };
}

export function FormOptionDtoToJSON(json: any): FormOptionDto {
    return FormOptionDtoToJSONTyped(json, false);
}

export function FormOptionDtoToJSONTyped(value?: FormOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
        'description': value['description'],
        'statement': value['statement'],
        'processingPurpose': ProcessingPurposeToJSON(value['processingPurpose']),
        'employeeDataCategory': EmployeeDataCategoryToJSON(value['employeeDataCategory']),
        'columnConfig': TableColumnConfigDtoToJSON(value['columnConfig']),
        'isVisibleInDocumentExport': value['isVisibleInDocumentExport'],
        'optionVisibilityConditions': VisibilityConditionGroupToJSON(value['optionVisibilityConditions']),
        'isExclusive': value['isExclusive'],
    };
}

